import { createFileRoute } from '@tanstack/react-router'
import EditionERP from 'Edition/components/sections/ERP/EditionERP'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/erp')({
    component: EditionERP,
})
